// extracted by mini-css-extract-plugin
export default {"tableSkeleton":"table-skeleton_tableSkeleton__vuj59"};